<!--
Author:
Create Time: 2020-04-10 14:06:26
Description: 房源档案参照框
-->
<template>
  <el-dialog
    title="房源参照"
    class="com-populregister-ref"
    top="10vh"
    :before-close="handleCancel"
    :close-on-click-modal="false"
    v-dialogDrag
    :modal="false"
    :width="width"
    v-bind="{...$props, ...$attrs, visible: mVisible}"
  >
    <el-form
      :inline="true"
      :model="condition"
      size="mini"
      style="margin-top: 20px;"
      label-suffix=":"
    >
      <el-form-item label="项目">
        <treeSelect
          type="text"
          :data="projectTreeData"
          v-model="condition.projectId"
          label="name"
          clearable
          @changeValue="projectTreeChange"
        ></treeSelect>
      </el-form-item>

      <el-form-item label="楼栋">
        <treeSelect
          type="text"
          :data="proBuilderTreeData"
          v-model="condition.builderId"
          v-on:selected="handleOrgConfirm"
          label="name"
          clearable
        ></treeSelect>
      </el-form-item>

       <el-form-item label="房号">
        <el-input v-model="condition.number" placeholder="模糊查询"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <div style="padding: 0px 10px;height:360px; padding-bottom: 2em;">
      <el-table
        :data="pageData.list"
        border
        class="table"
        ref="multipleTable"
        align="center"
        :header-cell-style="{background:'#f2f2f2'}"
        :stripe="true"
        height="100%"
        @row-click="handleRowClick"
        @selection-change="handleSelectionChange"
        :key="multiple ? 'multiple' : 'radio'"
      >
        <el-table-column
          width="50"
          fixed="left"
          align="center"
          show-overflow-tooltip
          v-if="!multiple"
        >
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="selectedRowId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="50"
          fixed="left"
          align="center"
          show-overflow-tooltip
          
          v-if="multiple"
          type="selection"
        ></el-table-column>-->

        <el-table-column v-else type="selection" align="center" width="55"></el-table-column>

        <el-table-column
          type="index"
          label="序号"
          sortable
          width="55"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="projectName"
          align="center"
          label="项目"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="builderName"
          align="center"
          label="楼栋名称"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="code"
          align="center"
          label="房源编码"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="name"
          align="center"
          label="房源名称"
          min-width="180"
          show-overflow-tooltip
          sortable
        >
          <template slot="header" slot-scope="scope">
            <span class="col-filter">
              {{scope.column.label}}
              <el-popover placement="bottom-end" width="200" trigger="click">
                <div>
                  <el-input type="text" v-model="condition.name" placeholder="请输入" clearable></el-input>
                </div>
                <hr
                  style="background-color: lightgray; height: 1px; border: none; margin-top: 1em;"
                />
                <div style="display: flex; justify-content: space-evenly;">
                  <el-button type="text" @click="handleSimpleFilterOk()">确定</el-button>
                  <el-button type="text" @click="handleSimpleFilterCancel('name')">重置</el-button>
                </div>
                <i slot="reference" class="icon-filter" @click.stop></i>
              </el-popover>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="number"
          align="center"
          label="房源号"
          min-width="180"
          show-overflow-tooltip
          sortable
        >
          <template slot="header" slot-scope="scope">
            <span class="col-filter">
              {{scope.column.label}}
              <el-popover placement="bottom-end" width="200" trigger="click">
                <div>
                  <el-input type="text" v-model="condition.number" placeholder="请输入" clearable></el-input>
                </div>
                <hr
                  style="background-color: lightgray; height: 1px; border: none; margin-top: 1em;"
                />
                <div style="display: flex; justify-content: space-evenly;">
                  <el-button type="text" @click="handleSimpleFilterOk()">确定</el-button>
                  <el-button type="text" @click="handleSimpleFilterCancel('number')">重置</el-button>
                </div>
                <i slot="reference" class="icon-filter" @click.stop></i>
              </el-popover>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="unit"
          align="center"
          label="单元"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="floor"
          align="center"
          label="楼层"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="households"
          align="center"
          label="户数"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="coveredArea"
          align="center"
          label="建筑面积"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="costArea"
          align="center"
          label="收费面积"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="satusName"
          align="center"
          label="房源状态"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="busformatName"
          align="center"
          label="业态"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="roomBuildingArea"
          align="center"
          label="套内面积"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="commonalityArea"
          align="center"
          label="公摊面积"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>

        <el-table-column
          prop="createUserName"
          align="center"
          label="创建人"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="创建时间"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="updateUserName"
          align="center"
          label="最后修改人"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          align="center"
          label="最后修改时间"
          min-width="180"
          show-overflow-tooltip
          sortable
        ></el-table-column>
      </el-table>
      <div data-ignore-class="pagination">
        <pagination
          data-ignore-style="float:right"
          style="text-align: right;"
          :page-list="pageData"
          @pagesearch="handlePage"
        ></pagination>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" size="medium" icon="el-icon-back">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" size="medium" icon="el-icon-document">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import accounting from "accounting"; // 数字格式

function newSearchCondition() {
  return {
    // 查询列表数据的条件
    loginUser: window.sessionStorage.getItem("userId"),
    projectId: undefined,
    builderId: undefined,
    name: undefined,
    isHouse:undefined,
    number: undefined
  };
}

export default {
  name: "proRoomRegisterRef",
  data() {
    return {
      projectTreeData: [],
      proBuilderTreeData: [],
      condition: newSearchCondition(),
      pageData: {
        list: [],
        pageNumber: 1,
        pageSize: 10,
        totalCount: 0,
        totalPage: 0
      },
      selectedRowId: "", //单选列表选中的id

      selection: [],
      mVisible: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.condition = newSearchCondition();
        if (this.isCar == true) {
          this.condition.isCarport = "是";
        }
        //判断是否自查选房子,不查询车位
        if(this.isHouse){
          this.condition.isCarport='否';
        }
        this.condition.populId = this.populIdCondition;
        this.condition.houseListCondition = this.houseListCondition;
        //alert(this.populIdCondition);
        if (this.buildId != "" && this.buildId != undefined) {
          this.condition.buildId = this.buildId;
        }
        this.search().then(() => (this.mVisible = true));
        this.initSelect();

        this.selectedRowId = null;
        this.selection = [];
      } else {
        this.mVisible = false;
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: String,
      default: () => "80%"
    },
    populIdCondition: {
      //应用收费计算新增筛选属性：populId 查询此客户下所有房产
      type: String,
      default: () => ""
    },
    houseListCondition: {
      type: String,
      default: () => ""
    },
    isCar: {
      type: Boolean,
      default: () => false
    },
    isHouse: {
      type: Boolean,
      default: () => false
    },
    buildId: {
      type: String,
      default: () => ""
    }
  },
  methods: {
    handleOrgConfirm(obj) {
      if (obj.isBuilder === "N") {
        return this.$message.warning("请选择楼栋！");
      }
    },
    initSelect(disabledCondition) {
      this.$http
        .post(this.api.ProProjectGetTree, {
          condition: this.condition
        })
        .then(res => {
          if (res.data.code === "200") {
            let newTreeData = [
              {
                id: "",
                name: "项目档案",
                children: res.data.body.proProjectList,
                isChildren: 1
              }
            ];
            this.projectTreeData = res.data.body.proProjectList;
          }
        });
    },
    projectTreeChange() {
      this.$http
        .post(this.api.ProBuilderQueryTreeListByProjectId, {
          condition: this.condition
        })
        .then(res => {
          if (res.data.code === "200") {
            let newTreeData = [
              {
                id: "",
                name: "项目、楼栋档案",
                children: res.data.body.proBuilderList,
                isChildren: 1
              }
            ];
            this.proBuilderTreeData = res.data.body.proBuilderList;
          }
        });
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      if (this.multiple ? this.selection.length === 0 : !this.selectedRowId) {
        this.$message.warning("请选择数据");
        return;
      }
      this.$emit(
        "confirm",
        this.multiple
          ? this.selection
          : this.pageData.list.find(item => item.id === this.selectedRowId)
      );
    },
    search() {
      this.pageData.pageNumber = 1;
      return this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    },
    getData(number, size) {
      return this.$http
        .post(this.api.ProRoomQueryList, {
          condition: this.condition,
          number: number,
          size: size
        })
        .then(res => {
          if (res.data && res.data.code === "200") {
            this.pageData.list = res.data.body.records;
            this.pageData.totalCount = res.data.body.total;
            this.pageData.totalPage = res.data.body.pages;
          }
        });
    },
    handlePage(number, size) {
      this.pageData.pageNumber = number;
      this.pageData.pageSize = size;
      this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    },
    //行选择
    handleRowClick(row) {
      this.selectedRowId = row.id;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    }
  },
  mounted() {}
};
</script>

<style scoped lang="less">
// .com-populregister-ref {}
</style>



// WEBPACK FOOTER //
// src/components/proRoomRegister/proRoomRegisterRef.vue